document.addEventListener('DOMContentLoaded', function() {
    // Get all block elements by a common class
    const blocks = document.querySelectorAll('.article-bloc-product-details-container');

    // Loop through each block and apply the JavaScript logic
    blocks.forEach(block => {
        const blockId = block.getAttribute('id');
        const attributesContainer = block.querySelector('.attributes-container');
        const rows = attributesContainer.querySelectorAll('.row');
        const seeMoreButton = block.querySelector(`#see-more-button-${blockId}`);
        const seeLessButton = block.querySelector(`#see-less-button-${blockId}`);

        // Initial check to see if the buttons need to be displayed
        checkRowCount();

        // Function to check the number of visible rows and toggle button visibility
        function checkRowCount() {
            if (rows.length > 7) {
                for (let i = 6; i < rows.length; i++) {
                    rows[i].classList.add('hidden-row');
                }
            }
            else {
                if (seeMoreButton)
                    seeMoreButton.style.display = 'none';
            }
        }

        // Function to toggle hidden rows visibility
        function toggleHiddenRows(){
            const hiddenRows = block.querySelectorAll('.hidden-row');
            hiddenRows.forEach(row => {
                if (row.style.display === 'none' || row.style.display === '') {
                    row.style.display = 'block';
                } else {
                    row.style.display = 'none';
                }
            });

            // Toggle the button states
            if (seeMoreButton.style.display === 'flex'|| seeMoreButton.style.display === '') {
                seeMoreButton.style.display = 'none';
                seeLessButton.style.display = 'flex';
            } else {
                seeMoreButton.style.display = 'flex';
                seeLessButton.style.display = 'none';
            }
        }

        // Attach event listeners to the buttons
        if(seeMoreButton){
            seeMoreButton.addEventListener('click', toggleHiddenRows);
            seeLessButton.addEventListener('click', toggleHiddenRows);
        }
    });
});
